<template>
  <v-text-field
    height="40"
    color="allout-grey"
    hide-details="auto"
    :class="classes"
    :type="type"
    :value="value"
    :disabled="disabled"
    :placeholder="placeholder"
    :maxlength="maxlength"
    :name="name"
    :autofocus="autofocus"
    :required="required"
    :rules="rules"
    outlined
    @input="handleInput"
  />
</template>

<script>
export default {
  name: 'TextInput',
  props: {
    name: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    maxlength: {
      type: Number,
      default: 50
    },
    type: {
      type: String,
      default: 'text'
    },
    classes: {
      type: String,
      default: '',
      required: false
    },
    value: {
      type: String,
      default: '',
      required: false
    },
    autofocus: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    rules: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    placeholder: vm => (vm.required ? `${vm.label} *` : vm.label)
  },
  methods: {
    handleInput(value) {
      this.$emit('input', value)
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep {
  .v-input__slot {
    min-height: 40px !important;
  }

  .v-text-field__details {
    margin-bottom: 0 !important;
  }
}
</style>
